import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import {providePrimeNG} from 'primeng/config';
import {GmDesignSystem} from '@geodan/primeng-gm-design-system';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), provideHttpClient(),
    providePrimeNG({theme:
        {
          preset: GmDesignSystem,
          options: {
            darkModeSelector: false
          }
        }
    }),
  ]
};
